import { useAuth } from '@/contexts/AuthContext';
import { useFetchWorkSessions } from './useWorkSessions';

interface UseSessionAlertsParams {
    page?: number;
    limit?: number;
    search?: string;
}

export const useSessionAlerts = (params?: UseSessionAlertsParams) => {
    const { user } = useAuth();

    const { data, isLoading } = useFetchWorkSessions({
        companyId: user?.companyId,
        hasComment: true,
        isReviewed: false,
        page: params?.page ?? 1,
        limit: params?.limit ?? 10,
        search: params?.search,
    });

    return {
        alerts: data?.workSessions ?? [],
        count: data?.pagination.total ?? 0,         // total réel depuis le serveur
        totalPages: data?.pagination.totalPages ?? 0,
        isLoading,
    };
};
